// src/checkoutUtils.js
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, addDoc, onSnapshot } from 'firebase/firestore';

export const handleCheckout = async (productType) => {
  const db = getFirestore();
  const auth = getAuth();
  const currentUser = auth.currentUser;
  let priceId, successUrl;
  
    if (!currentUser) {
      alert('You must be signed in to subscribe.');
      return;
    }

    if (productType === 'builder') {
      priceId = 'price_1RDvq7AWnK0AWkSwXR6dgZuC'; // Resume Builder
      successUrl = `${window.location.origin}/print`;
    } else {
      priceId = 'price_1RDvq7AWnK0AWkSwXR6dgZuC'; // Navbar Upgrade
      successUrl = window.location.origin;
    }
  
    try {
      // Add a document to the 'checkout_sessions' sub-collection
      const checkoutSessionsRef = collection(db, 'users', currentUser.uid, 'checkout_sessions');
      const docRef = await addDoc(checkoutSessionsRef, {
        price: priceId, 
        success_url: window.location.origin,
        cancel_url: window.location.origin,
      });
  
      // Listen for changes to the checkout session document
      onSnapshot(docRef, (doc) => {
        const { error, url } = doc.data();
  
        if (error) {
          alert(`An error occurred: ${error.message}`);
          console.error('Stripe Checkout error:', error);
        }
  
        if (url) {
          // Redirect to the Stripe Checkout page
          window.location.assign(url);
        }
      });
    } catch (error) {
      console.error('Error creating checkout session:', error);
      alert('Failed to create checkout session. Please try again.');
    }
  };